<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="currentBranchLink"
    [currentPageValue]="editMode ? 'Edit Branch' : 'Add Branch'"
  ></page-header-breadcrumb>

  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addBranchForm" (ngSubmit)="onAddBranchSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-en-name">
                Branch EN Name
              </label>
              <input
                class="form-control"
                id="branch-en-name"
                formControlName="branchEnName"
                placeholder="Branch EN Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchEnName.dirty) &&
                  addBranchForm.controls.branchEnName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchEnName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchEnName.errors.pattern">
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-ar-name">
                Branch AR Name
              </label>
              <input
                required
                class="form-control"
                id="branch-ar-name"
                placeholder="Branch AR Name"
                formControlName="branchArName"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchArName.dirty) &&
                  addBranchForm.controls.branchArName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchArName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchArName.errors.pattern">
                  This field accept only Arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-en-address">
                Branch EN address
              </label>
              <input
                required
                class="form-control"
                id="branch-en-address"
                placeholder="Branch EN address"
                type="text"
                formControlName="branchEnAddress"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchEnAddress.dirty) &&
                  addBranchForm.controls.branchEnAddress.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchEnAddress.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchEnAddress.errors.pattern">
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-ar-address">
                Branch AR address
              </label>
              <input
                required
                class="form-control"
                id="branch-ar-address"
                formControlName="branchArAddress"
                placeholder="Branch Arabic address"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchArAddress.dirty) &&
                  addBranchForm.controls.branchArAddress.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchArAddress.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchArAddress.errors.pattern">
                  This field accept only Arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-phone">
                Phone Number
              </label>
              <input
                class="form-control"
                id="branch-phone"
                formControlName="branchPhone"
                placeholder=" Phone Number"
                type="tel"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchPhone.dirty) &&
                  addBranchForm.controls.branchPhone.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchPhone.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchPhone.errors.pattern">
                  This field accept only a valid phone number!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-email">
                Email
              </label>
              <input
                class="form-control"
                id="branch-email"
                formControlName="branchEmail"
                placeholder=" Email"
                type="email"
              />
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchEmail.dirty) &&
                  addBranchForm.controls.branchEmail.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchEmail.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addBranchForm.controls.branchEmail.errors.pattern">
                  This field accept only a valid email address!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-city">
                Cities
              </label>
              <select
                formControlName="branchCity"
                (change)="onCityChange($event.target.value)"
                class="form-control"
                id="branch-city"
                name="branch-city"
              >
                <option
                  *ngFor="let city of cities; let i = index"
                  [value]="city.id"
                >
                  {{ city.name }}
                </option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchCity.dirty) &&
                  addBranchForm.controls.branchCity.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchCity.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="branch-area">
                Areas
              </label>
              <select
                formControlName="branchArea"
                (change)="onAreaChange($event.target.value)"
                class="form-control"
                id="branch-area"
                name="branch-area"
              >
                <option
                  *ngFor="let area of areas; let i = index"
                  [value]="area.id"
                >
                  {{ area.name }}
                </option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addBranchForm.controls.branchArea.dirty) &&
                  addBranchForm.controls.branchArea.errors
                "
                class="input-errors"
              >
                <p *ngIf="addBranchForm.controls.branchArea.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row d-flex align-items-center">
          <div class="col-6 d-flex align-items-center">
            <label class="mr-6 mb-0" for="active-check">is Active</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="active-check"
                formControlName="branchActive"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
          <div class="col-6">
            <div class="form-group">
              <div
                class="icon-image-placeholder placeholder"
                id="placeholder"
                (click)="onImageUpload($event)"
                accept=".jpg,.png"
                name="img"
              ></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addBranchForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="currentBranchLink"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
